import { render, staticRenderFns } from "./ClientHeading.vue?vue&type=template&id=4d58ef58&scoped=true"
import script from "./ClientHeading.vue?vue&type=script&lang=ts"
export * from "./ClientHeading.vue?vue&type=script&lang=ts"
import style0 from "./ClientHeading.vue?vue&type=style&index=0&id=4d58ef58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58ef58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d58ef58')) {
      api.createRecord('4d58ef58', component.options)
    } else {
      api.reload('4d58ef58', component.options)
    }
    module.hot.accept("./ClientHeading.vue?vue&type=template&id=4d58ef58&scoped=true", function () {
      api.rerender('4d58ef58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/ClientHeading.vue"
export default component.exports